import { Lookup } from "projects/shared/src/models/lookup"
import { MonitorTaskStatusEnum } from "./enums/MonitorTaskStatusEnum"
import { TaskPriorityEnumValues } from "./enums/TaskPriorityEnumValues"
import { StoreTypeEnum } from "./enums/StoreTypeEnum"
import { SystemTaskTypeEnum } from "./enums/SystemTaskTypeEnum"


export class MonitorTaskDetails {
  status: Status
  priority: Priority
  taskId: number
  taskNumber: string
  duedate: Date
  branch: string
  city: string
  operatorLogo: string
  ambassadorData: AmbassadorData
  canDelete: boolean
  haveAmbassador: boolean
  trackName: string
  creationDate: Date
  updateDate: Date
  approvalDate: Date
  assignedDate: Date
  canViewPlan: boolean
  plainId: number
  plainNumber: string
  modificationReasons: ModificationReason[]
  economicOperatorName: string
  basketName: string
  storeType: StoreTypeEnum
  instructions: string
  website: string
  group: string
  assignedTaskType: SystemTaskTypeEnum
  longitude: string
  latitude: string
}

export interface Status {
  title: string
  statusCode: MonitorTaskStatusEnum
}

export interface ModificationReason {
  title: string
  reason: string
  date: Date
  status: MonitorTaskStatusEnum
}

export class Priority {
  id: number
  name: string
  code: TaskPriorityEnumValues
  icon: any
}

export interface AmbassadorData {
  name: string
  image: string
}
